export default __webpack_public_path__ + "static/media/design.360ab470.svg";